import { Empty, Space, Table, Tag } from 'antd';
import React, { Fragment, useMemo } from 'react';
import { FilterOutlined } from '@ant-design/icons';

import { ICommunityTag } from 'features/communities/interfaces';
import { PaginatedResponse } from 'features/communities/interfaces/PaginatedResponse';
import { TableFilter } from 'shared/ui/TableFilter';

import { ChatAvatar } from './ChatAvatar';
import {
    ChatProps,
    ChatType,
} from '../../../../communities/components/Chats/interface/chats.interface';
import { useAppDispatch, useAppSelector } from '../../../../../store';
import { dynamicPagination } from '../../../../../utils/common/dynamicPagination';
import { setCurrentChat } from '../../../store/analyticSelectorSlice';
import { typeLabels } from '../service/chatlist.interface';
import {
    selectAnalyticsFilters,
    updateFilters,
} from '../../../store/analyticFiltersSlice';

type Props = {
    readonly source: PaginatedResponse<ChatProps>;
    readonly loading?: boolean;
    readonly onSelect?: (ids: number[]) => void;
};
export const ChatListTable = ({ source, loading }: Props) => {
    const filters = useAppSelector(selectAnalyticsFilters);
    const dispatch = useAppDispatch();

    const pagination = useMemo(
        () => dynamicPagination(filters, updateFilters, source?.total, 'Чатов'),
        [filters, updateFilters, source?.total]
    );

    return (
        <Table
            onRow={record => {
                return {
                    onClick: () => {
                        dispatch(setCurrentChat(record));
                        dispatch(
                            updateFilters({
                                chat: record.id,
                                offset: 0,
                            })
                        );
                    },
                };
            }}
            loading={loading}
            rowKey={community => community.id}
            locale={{ emptyText: <Empty description='Нет чатов' /> }}
            dataSource={source.items}
            pagination={pagination}
        >
            <Table.Column
                title={
                    <TableFilter<string>
                        title='Название сообщества'
                        onChange={name => {
                            dispatch(
                                updateFilters({
                                    name: name,
                                })
                            );
                        }}
                        value={filters.name}
                    >
                        <TableFilter.Text />
                    </TableFilter>
                }
                render={chat => (
                    <ChatAvatar title={chat.title} image={chat.image} />
                )}
            />

            <Table.Column<ChatProps>
                width='20%'
                sortDirections={['ascend', 'descend']}
                sorter={(a, b) =>
                    typeLabels[a.type].localeCompare(typeLabels[b.type], 'ru')
                }
                title='Тип сообщества'
                dataIndex='type'
                render={(type: ChatType) => <Space>{typeLabels[type]}</Space>}
            />

            <Table.Column
                width={'400px'}
                title={
                    <TableFilter<string[]>
                        icon={<FilterOutlined />}
                        onChange={tags_names => {
                            dispatch(
                                updateFilters({
                                    tags_names: tags_names,
                                })
                            );
                        }}
                        title='Теги'
                        value={filters.tags_names}
                    >
                        <TableFilter.Tags />
                    </TableFilter>
                }
                dataIndex={'tags'}
                render={(tags: ICommunityTag[]) => (
                    <Fragment>
                        <Space>
                            {tags.map((tag, index) => (
                                <Tag key={index}>{tag.name}</Tag>
                            ))}
                        </Space>
                    </Fragment>
                )}
            />
        </Table>
    );
};
